import { createResource } from '@atlassian/react-resource-router';
import { getProjectKeyOrId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-or-id/index.tsx';

const getDataLoader = () =>
	import(
		/* webpackChunkName: "async-resource-sender-name", jiraSpaEntry: "async-resource-sender-name" */ './get-data'
	);

export const senderNameResource = createResource<string>({
	type: 'CSM_SENDER_NAME',
	getKey: (matchedRoute) => `sender-name-${getProjectKeyOrId(matchedRoute.match)}`,
	getDataLoader,
});
